<template>
  <v-card class="pa-2 mb-4">
    <v-card-title class="text-h6 mt-2 mb-2">
      <h4 class="mb-0">
        <strong>LPN Actual</strong>
      </h4>
    </v-card-title>
    <v-card-text>
      <div class="space-y-3">
        <div class="d-flex justify-space-between align-center">
          <span class="text-body-2 text-medium-emphasis">LPN:</span>
          <h6 class="mb-0"><strong>{{ currentLpn }}</strong></h6>
        </div>
        
        <template v-if="currentContainer">
          <div class="d-flex justify-space-between align-center">
            <span class="text-body-2 text-medium-emphasis">Total Pedidos:</span>
            <span class="text-body-2">{{ currentContainer.orders.length }}</span>
          </div>
          
          <div class="d-flex justify-space-between align-center">
            <span class="text-body-2 text-medium-emphasis">Completados:</span>
            <span class="text-body-2 text-success">
              {{ completedOrdersCount }}
            </span>
          </div>
          
          <div class="d-flex justify-space-between align-center">
            <span class="text-body-2 text-medium-emphasis">Pendientes:</span>
            <span class="text-body-2 text-warning">{{ pendingOrdersCount }}</span>
          </div>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CurrentLPN',
  props: {
    currentLpn: {
      type: String,
      required: true
    },
    currentContainer: {
      type: Object,
      default: null
    },
    pendingOrdersCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    completedOrdersCount() {
      return this.currentContainer?.orders.filter(order => order.status === "completed").length || 0
    }
  }
}
</script>

<style scoped>
.space-y-3 > * + * {
  margin-top: 12px;
}

.font-mono {
  font-family: 'Courier New', monospace;
}
</style>